"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builtin_functions = exports.arity = void 0;
const constants_1 = require("../../constants");
const free_1 = require("./free");
const malloc_1 = require("./malloc");
const printf_1 = require("./printf");
const arity = (f) => {
    return f.length - 1;
};
exports.arity = arity;
exports.builtin_functions = {
    printf: {
        type: 'Builtin',
        returnType: constants_1.VOID_TYPE,
        apply: (_memory, x, ...args) => console.log((0, printf_1.printfFunction)(x, ...args)),
        arity: 0,
        hasVarArgs: true,
        name: 'printf'
    },
    malloc: {
        type: 'Builtin',
        returnType: constants_1.VOID_POINTER_TYPE,
        apply: (memory, x) => (0, malloc_1.mallocFunction)(x, memory),
        arity: 1,
        hasVarArgs: false,
        name: 'malloc'
    },
    free: {
        type: 'Builtin',
        returnType: constants_1.VOID_TYPE,
        apply: (memory, x) => (0, free_1.freeFunction)(x, memory),
        arity: 1,
        hasVarArgs: false,
        name: 'free'
    }
};
//# sourceMappingURL=index.js.map